import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { usePinnedColumnsContext } from 'shared/components/Board/context';
import { ButtonIcon } from 'shared/components/Button';

type BoardColumnPinButtonProps = {
  columnId: string;
};

export const BoardColumnPinButton = ({
  columnId,
}: BoardColumnPinButtonProps) => {
  const { pinnedColumns, setPinnedColumns } = usePinnedColumnsContext();

  return (
    <ButtonIcon
      aria-label="keep"
      onClick={() => setPinnedColumns(columnId)}
      data-testid="keep-btn"
      variant="ghost"
      rounded="full"
      backgroundColor={
        pinnedColumns.has(columnId)
          ? 'var(--bgCompSecondaryMid)'
          : 'transparent'
      }
    >
      <Icon
        name={iconNames.keep}
        fill={
          pinnedColumns.has(columnId)
            ? 'var(--bgCompAccent)'
            : 'var(--fgPrimary)'
        }
        width="18px"
        height="18px"
      />
    </ButtonIcon>
  );
};
